import {useRef, useState} from "react";

export const AvatarSessionState = {
  INACTIVE: "inactive",
  CONNECTING: "connecting",
  CONNECTED: "connected",
};

export const useAvatarLifecycleMachine = () => {
  const avatarSessionStateRef = useRef(AvatarSessionState.INACTIVE);
  const [avatarSessionState, setAvatarSessionState] = useState(
    AvatarSessionState.INACTIVE,
  );

  const [avatarState, setAvatarState] = useState({
    stream: null,
    avatarData: null,
  });

  const [activityState, setActivityState] = useState({
    isAvatarTalking: false,
    isUserTalking: false,
    isListening: false,
    connectionQuality: "UNKNOWN",
  });

  const [messageState, setMessageState] = useState({
    lastSpokenMessage: "",
    firstMessageSent: false,
  });

  const [silenceState, setSilenceState] = useState({
    silence: false,
    countdown: 115,
    stopVoice: true,
  });

  return {
    avatarSessionStateRef,
    avatarSessionState,
    setAvatarSessionState,
    avatarState,
    setAvatarState,
    activityState,
    setActivityState,
    messageState,
    setMessageState,
    silenceState,
    setSilenceState,
  };
};
